import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SharedState } from '../reducers/base-shared.reducer';

export const getShared = createFeatureSelector<SharedState>('shared');
export const getCountryList = createSelector(getShared, (state) => state?.countryList);
export const getCountryListStatus = createSelector(getShared, (state) => state?.countryList.ok);
export const getQualifications = createSelector(getShared, (state) => state?.qualifications);
export const getQualificationCategories = createSelector(getShared, (state) => state?.qualificationCategories);

export const getCustomerDepartmentQualificationsList = createSelector(
  getShared,
  (state) => state?.customerDepartmentQualifications
);

export const getPspBranches = createSelector(getShared, (state) => state.pspBranches);
export const getProfile = createSelector(getShared, (state) => state?.profileData);
export const getProfileData = createSelector(getShared, (state) => state?.profileData?.data);
export const getRequirements = createSelector(getShared, (state) => state?.requirements);
export const getDepartments = createSelector(getShared, (state) => state?.departments);
export const getDepartmentUsers = createSelector(getShared, (state) => state?.departmentUsers);
export const getPspPriceList = createSelector(getShared, (state) => state.pspPriceList);
export const getDefaultShiftTimes = createSelector(getShared, (state) => state.defaultShiftTimes);
export const getPSPCustomerSurcharges = createSelector(getShared, (state) => state.pspCustomerSurcharges);
export const getUserNotifications = createSelector(getShared, (state) => state.userNotifications);
export const getAppRouterState = createSelector(getShared, (state) => state.appRouter);
export const getCustomerDepartmentFavouriteQualifications = createSelector(
  getShared,
  (state) => state.customerDepartmentFavouriteQualifications
);
export const getCurrentLanguage = createSelector(getShared, (state) => state.language.current);
export const getSystemAlertsData = createSelector(getShared, (state) => state.systemAlerts.data);
export const getCurrentBranchUsers = createSelector(getShared, (state) => state?.currentBranchUsers);
export const getSidebarInitialOpening = createSelector(getShared, (state) => state.isSidebarInitialOpening);
export const getIndustrySurcharges = createSelector(getShared, (state) => state.industrySurcharges);

export const getCalculatedEPDate = createSelector(
  getShared,
  (state: SharedState): { data: string | undefined; ok: boolean | undefined } => state.calculatedEPDate
);

export const getCalculatedMLPDate = createSelector(
  getShared,
  (state: SharedState): { data: string | undefined; ok: boolean | undefined } => state.calculatedMLPDate
);
